<div class="lang-switcher-container">
  <sv-dropdown
    class="dropdown-selectbox"
    [(ngModel)]="selectedLang"
    [items]="langOptions"
    bindLabel="text"
    bindValue="value"
    [clearable]="false"
    [searchable]="false"
    [hideSelected]="true"
    (change)="changeLanguage()"
  >
    <ng-template svDropdownLabel let-item="item">
      <button class="btn btn-clean btn--iconMuted">
        <span class="c-btn__title">{{ item.label }}</span>
        <sv-icon iconClass="iconFont iconFont-globe"></sv-icon>
      </button>
    </ng-template>
  </sv-dropdown>
</div>
